export const planRates = {
  REFERRAL: 'referral',
  VIRTUAL: 'virtual',
  TIER1: 'tier1',
  TIER2: 'tier2',
  NETWORK: 'network',
}

export const planTemplateTypes = {
  OH_STANDARD: 'oh_standard',
  AZ_STANDARD: 'az_standard',
  OH_CATASTROPHIC: 'oh_catastrophic',
  AZ_CATASTROPHIC: 'az_catastrophic',
  AZ_COMPLETE_ELITE: 'az_complete_elite',
  OH_COMPLETE_ELITE: 'oh_complete_elite',
  AZ_SMALL_GROUPS: 'az_small_groups',
}
